import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
type FloatingCTAProps = {
  anchorRef: React.RefObject<HTMLElement>;
};
export function FloatingCTA({
  anchorRef
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = anchorRef.current;
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, [anchorRef]);
  return <AnimatePresence data-id="element-34" data-mp="2fsbf9cuk9glv">
      {visible && <motion.div initial={{
      y: "120%"
    }} animate={{
      y: 0
    }} exit={{
      y: "120%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-100 bg-cream/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur sm:bottom-4 sm:mx-auto sm:w-[28rem] sm:rounded-2xl sm:border sm:shadow-xl" data-id="element-35" data-mp="2awctzy4j4epo">
          <CTAButton label="Get it now · only $27" compact shake data-id="element-36" data-mp="3331b9rr913my" />
        </motion.div>}
    </AnimatePresence>;
}